
import { Options, Vue } from "vue-class-component"; //基本需要\

import roma from "../assets/json1/roma.js";
import * as echarts from "echarts";
import passion1 from "@/assets/js/passion1.js";
import { store } from "@/store"; //引入仓库
import { ElMessage } from "element-plus";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import {
  dispatchGetSkinManagement,
  dispatchGetSkinLineView,
  dispatchUpdateSkinLineView,
  dispatchGetSkinLinePkg,
  dispatchGetSkinLineDate,
} from "@/store/performance/actions";
// import God from "@/assets/js/god.js";
import {
  readGetSkinManagement,
  readGetSkinLineView,
  readGetSkinDate,
  readGetSkinPkg,
} from "@/store/performance/getters";
export default class TestReport extends Vue {
  public date: any = [];
  public abnormal_type = "";
  public auto_abnormal_type = "";
  public localProject = Number(getLocalProject()); //得到本地的项目
  public list = [
    { img: require("../../assets/test/6.jpg") },
    { img: require("../../assets/test/10.jpg") },
    { img: require("../../assets/test/8.jpg") },
    { img: require("../../assets/test/10.jpg") },
    { img: require("../../assets/test/9.jpg") },
  ];
  public imgWidth: any = "";
  public imgWidthList = [];
  public imgHeight = "";
  public screenList = [
    { name: "全部", value: "all" },
    { name: "未标记", value: "0" },
  ];
  //  public created(){
  //    new God().init();
  //  }
  public async mounted() {
    // new God().init();

    if (this.$route.query.imgIndex) {
      const project: any = Number(this.$route.query.project);
      let pkg: any = this.$route.query.pkg;
      let date: any = this.$route.query.date;
      let type: any = this.$route.query.type;
      let quality: any = this.$route.query.quality;
      let imgIndex = Number(this.$route.query.imgIndex);

      await dispatchGetSkinLineDate(store, { project: project });
      await dispatchGetSkinLinePkg(store, {
        project: this.localProject,
        date: date,
      });
      this.form.date_version = date;
      this.form.scene = type;
      this.form.pkg = pkg;
      this.form.screen = this.screenList[0].value;

      this.form.draw = quality;
      await dispatchGetSkinLineView(store, {
        project: this.localProject,
        pkg: this.form.pkg,
        quality: this.form.draw,
        type: Number(this.form.scene),
        date: this.form.date_version,
        mark: this.form.screen,
      });
      // this.form.draw = this.form.scene === "1" ? "High" : "HD";
      await dispatchGetSkinLineView(store, {
        project: this.localProject,
        pkg: this.form.pkg,
        quality: this.form.draw,
        type: Number(this.form.scene),
        date: this.form.date_version,
        mark: this.form.screen,
      });
      await this.skinLineViewData;
      (await type) == "1" ? this.skinLineViewOut : this.skinLineViewIn;

      this.imgTableData(this.form.scene, this.form.draw);
      this.imgStatus = (readGetSkinLineView(store) as any)?.image_list[
        imgIndex
      ]?.status;
      this.abnormal_type = (readGetSkinLineView(store) as any)?.image_list[
        imgIndex
      ]?.abnormal_type;
      this.auto_abnormal_type = (readGetSkinLineView(store) as any)?.image_list[
        imgIndex
      ]?.auto_abnormal_type;

      this.file_path = (readGetSkinLineView(store) as any)?.image_list[
        imgIndex
      ]?.file_path;
      this.total = (readGetSkinLineView(store) as any)?.image_list.length;
      this.numIndex = Number(imgIndex) + 1;

      let imgData = document.getElementById("imgBox");
      let imgCenter = document.getElementById("center");
      this.imgWidth = imgCenter?.offsetWidth;

      imgData.style.left = -(this.imgWidth * imgIndex) + "px";
      this.num = -(this.imgWidth * imgIndex);
      if (this.skinLineView[imgIndex]?.width > imgCenter?.offsetWidth) {
        let size = this.skinLineView[imgIndex]?.width / imgCenter?.offsetWidth;
        this.imgHeight = this.skinLineView[imgIndex]?.height / size + "px";
      } else {
        let size = imgCenter?.offsetWidth / this.skinLineView[imgIndex]?.width;
        this.imgHeight = this.skinLineView[imgIndex]?.height * size + "px";
      }
    } else {
      await dispatchGetSkinLineDate(store, { project: this.localProject });
      await dispatchGetSkinLinePkg(store, {
        project: this.localProject,
        date: readGetSkinDate(store)[0].date,
      });
      await this.defaultData();
      this.form.screen = this.screenList[0].value;
      // type: Number(this.form.scene),
      await dispatchGetSkinLineView(store, {
        project: this.localProject,
        pkg: this.form.pkg,
        quality: this.form.draw,
        type: Number(this.form.scene),
        date: this.form.date_version,
        mark: this.form.screen,
      });
      this.form.draw = this.form.scene === "1" ? "High" : "HD";
      this.$router.push({
        query: {
          ...this.$route.query,
          pkg: this.form.pkg,
          date: this.form.date_version,
          type: this.form.scene,
          quality: this.form.draw,
          imgIndex: 0,
        },
      });
      await dispatchGetSkinLineView(store, {
        project: this.localProject,
        pkg: this.form.pkg,
        quality: this.form.draw,
        type: Number(this.form.scene),
        date: this.form.date_version,
        mark: this.form.screen,
      });
      await this.skinLineViewData;
      await this.skinLineViewOut;
      //  this.date=[{name:'Hight',mark:0,inMark:0,outMak:0}]
      this.imgTableData(this.form.scene, this.form.draw);

      this.imgStatus = (readGetSkinLineView(
        store
      ) as any)?.image_list[0]?.status;
      this.total = (readGetSkinLineView(store) as any)?.image_list.length;
      this.numIndex = 1;
      this.abnormal_type = (readGetSkinLineView(
        store
      ) as any)?.image_list[0]?.abnormal_type;
      this.auto_abnormal_type = (readGetSkinLineView(
        store
      ) as any)?.image_list[0]?.auto_abnormal_type;

      this.file_path = (readGetSkinLineView(
        store
      ) as any)?.image_list[0]?.file_path;
      let imgData = document.getElementById("imgBox");
      let imgCenter = document.getElementById("center");
      this.imgWidth = imgCenter?.offsetWidth;
      this.num = 0;
      if (this.skinLineView[0]?.width > imgCenter?.offsetWidth) {
        let size = this.skinLineView[0]?.width / imgCenter?.offsetWidth;
        this.imgHeight = this.skinLineView[0]?.height / size + "px";
      } else {
        let size = imgCenter?.offsetWidth / this.skinLineView[0]?.width;
        this.imgHeight = this.skinLineView[0]?.height * size + "px";
      }
    }
  }
  public get skinLineView() {
    // if((readGetSkinLineView(store) as any)?.image_list?.length>0){
    //      this.list.forEach((v,i)=>{
    //   (readGetSkinLineView(store) as any)?.image_list.forEach((k,index)=>{
    //  if(i===index){
    //    k.file_name=v.img
    //  }
    //   })
    // })
    // }
    // (readGetSkinLineView(store) as any).image_list[0].file_path="../../assets/test/1231.png";
    // (readGetSkinLineView(store) as any).image_list[1].file_path="../../assets/test/2222.png"
    return (readGetSkinLineView(store) as any).image_list;
  }
  //  public get skinLineView(){

  //  return  (readGetSkinLineView(store) as any).image_list

  // }
  public async dateChange() {
    await dispatchGetSkinLinePkg(store, {
      project: this.localProject,
      date: this.form.date_version,
    });
    this.form.scene = this.sceneList[0].value;
    this.form.pkg = readGetSkinPkg(store)[0].pkg;
    this.form.screen = this.screenList[0].value;
    await dispatchGetSkinLineView(store, {
      project: this.localProject,
      pkg: this.form.pkg,
      quality: "",
      type: Number(this.form.scene),
      date: this.form.date_version,
      mark: this.form.screen,
    });
    this.form.draw = this.form.scene === "1" ? "High" : "HD";
    await dispatchGetSkinLineView(store, {
      project: this.localProject,
      pkg: this.form.pkg,
      quality: this.form.draw,
      type: Number(this.form.scene),
      date: this.form.date_version,
      mark: this.form.screen,
    });
    await this.skinLineViewData;
    this.$router.push({
      query: {
        ...this.$route.query,
        pkg: this.form.pkg,
        date: this.form.date_version,
        type: this.form.scene,
        quality: this.form.draw,
        imgIndex: 0,
      },
    });
    let imgData = document.getElementById("imgBox");
    let imgCenter = document.getElementById("center");
    this.imgWidth = imgCenter?.offsetWidth;
    this.num = 0;
    imgData.style.left = 0 + "px";
    this.imgStatus = (readGetSkinLineView(store) as any)?.image_list[0]?.status;
    this.abnormal_type = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.abnormal_type;
    this.auto_abnormal_type = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.auto_abnormal_type;
    this.file_path = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.file_path;
    this.total = (readGetSkinLineView(store) as any)?.image_list.length;
    this.numIndex = 1;
    if (this.skinLineView[0]?.width > imgCenter.offsetWidth) {
      let size = this.skinLineView[0]?.width / imgCenter.offsetWidth;
      this.imgHeight = this.skinLineView[0]?.height / size + "px";
    } else {
      let size = imgCenter.offsetWidth / this.skinLineView[0]?.width;
      this.imgHeight = this.skinLineView[0]?.height * size + "px";
    }
  }
  public async pkgChange() {
    this.form.scene = this.sceneList[0].value;
    this.form.screen = this.screenList[0].value;
    await dispatchGetSkinLineView(store, {
      project: this.localProject,
      pkg: this.form.pkg,
      quality: "",
      type: Number(this.form.scene),
      date: this.form.date_version,
      mark: this.form.screen,
    });
    this.form.draw = this.form.scene === "1" ? "High" : "HD";
    await dispatchGetSkinLineView(store, {
      project: this.localProject,
      pkg: this.form.pkg,
      quality: this.form.draw,
      type: Number(this.form.scene),
      date: this.form.date_version,
      mark: this.form.screen,
    });
    await this.skinLineViewData;
    this.$router.push({
      query: {
        ...this.$route.query,
        pkg: this.form.pkg,
        date: this.form.date_version,
        type: this.form.scene,
        quality: this.form.draw,
        imgIndex: 0,
      },
    });
    let imgData = document.getElementById("imgBox");
    let imgCenter = document.getElementById("center");
    this.imgWidth = imgCenter?.offsetWidth;
    this.num = 0;
    imgData.style.left = 0 + "px";
    this.imgStatus = (readGetSkinLineView(store) as any)?.image_list[0]?.status;
    this.abnormal_type = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.abnormal_type;
    this.auto_abnormal_type = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.auto_abnormal_type;
    this.file_path = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.file_path;
    this.total = (readGetSkinLineView(store) as any)?.image_list.length;
    this.numIndex = 1;
    if (this.skinLineView[0]?.width > imgCenter.offsetWidth) {
      let size = this.skinLineView[0]?.width / imgCenter.offsetWidth;
      this.imgHeight = this.skinLineView[0]?.height / size + "px";
    } else {
      let size = imgCenter.offsetWidth / this.skinLineView[0]?.width;
      this.imgHeight = this.skinLineView[0]?.height * size + "px";
    }
  }
  public async sceneChange() {
    this.form.screen = this.screenList[0].value;
    await dispatchGetSkinLineView(store, {
      project: this.localProject,
      pkg: this.form.pkg,
      quality: "",
      type: Number(this.form.scene),
      date: this.form.date_version,
      mark: this.form.screen,
    });
    this.form.draw = this.form.scene === "1" ? "High" : "HD";
    await dispatchGetSkinLineView(store, {
      project: this.localProject,
      pkg: this.form.pkg,
      quality: this.form.draw,
      type: Number(this.form.scene),
      date: this.form.date_version,
      mark: this.form.screen,
    });
    await this.skinLineViewData;
    this.$router.push({
      query: {
        ...this.$route.query,
        pkg: this.form.pkg,
        date: this.form.date_version,
        type: this.form.scene,
        quality: this.form.draw,
        imgIndex: 0,
      },
    });
    let imgData = document.getElementById("imgBox");
    let imgCenter = document.getElementById("center");
    this.imgWidth = imgCenter?.offsetWidth;
    this.num = 0;
    imgData.style.left = 0 + "px";
    this.imgStatus = (readGetSkinLineView(store) as any)?.image_list[0]?.status;
    this.abnormal_type = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.abnormal_type;
    this.auto_abnormal_type = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.auto_abnormal_type;
    this.file_path = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.file_path;
    this.total = (readGetSkinLineView(store) as any)?.image_list.length;
    this.numIndex = 1;
    if (this.skinLineView[0]?.width > imgCenter.offsetWidth) {
      let size = this.skinLineView[0]?.width / imgCenter.offsetWidth;
      this.imgHeight = this.skinLineView[0]?.height / size + "px";
    } else {
      let size = imgCenter.offsetWidth / this.skinLineView[0]?.width;
      this.imgHeight = this.skinLineView[0]?.height * size + "px";
    }
  }
  public async drawChange() {
    //  pkg: this.form.pkg,
    //   date: this.form.date_version,
    this.form.screen = this.screenList[0].value;
    await dispatchGetSkinLineView(store, {
      project: this.localProject,
      pkg: this.form.pkg,
      quality: this.form.draw,
      type: Number(this.form.scene),
      date: this.form.date_version,
      mark: this.form.screen,
    });
    await this.skinLineViewData;
    this.imgTableData(this.form.scene, this.form.draw);
    this.$router.push({
      query: {
        ...this.$route.query,
        pkg: this.form.pkg,
        date: this.form.date_version,
        type: this.form.scene,
        quality: this.form.draw,
        imgIndex: 0,
      },
    });

    let imgData = document.getElementById("imgBox");
    let imgCenter = document.getElementById("center");
    this.imgWidth = imgCenter?.offsetWidth;
    this.num = 0;
    imgData.style.left = 0 + "px";
    this.imgStatus = (readGetSkinLineView(store) as any)?.image_list[0]?.status;
    this.abnormal_type = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.abnormal_type;
    this.auto_abnormal_type = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.auto_abnormal_type;
    this.file_path = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.file_path;
    this.total = (readGetSkinLineView(store) as any)?.image_list.length;
    this.numIndex = 1;
    if (this.skinLineView[0]?.width > imgCenter.offsetWidth) {
      let size = this.skinLineView[0]?.width / imgCenter.offsetWidth;
      this.imgHeight = this.skinLineView[0]?.height / size + "px";
    } else {
      let size = imgCenter.offsetWidth / this.skinLineView[0]?.width;
      this.imgHeight = this.skinLineView[0]?.height * size + "px";
    }
  }
  public async screenChange() {
    //  pkg: this.form.pkg,
    //   date: this.form.date_version,
    await dispatchGetSkinLineView(store, {
      project: this.localProject,
      pkg: this.form.pkg,
      quality: this.form.draw,
      type: Number(this.form.scene),
      date: this.form.date_version,
      mark: this.form.screen,
    });
    await this.skinLineViewData;
    this.imgTableData(this.form.scene, this.form.draw);
    this.$router.push({
      query: {
        ...this.$route.query,
        pkg: this.form.pkg,
        date: this.form.date_version,
        type: this.form.scene,
        quality: this.form.draw,
        imgIndex: 0,
      },
    });

    let imgData = document.getElementById("imgBox");
    let imgCenter = document.getElementById("center");
    this.imgWidth = imgCenter?.offsetWidth;
    this.num = 0;
    imgData.style.left = 0 + "px";
    this.imgStatus = (readGetSkinLineView(store) as any)?.image_list[0]?.status;
    this.abnormal_type = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.abnormal_type;
    this.auto_abnormal_type = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.auto_abnormal_type;
    this.file_path = (readGetSkinLineView(
      store
    ) as any)?.image_list[0]?.file_path;
    this.total = (readGetSkinLineView(store) as any)?.image_list.length;
    this.numIndex = 1;
    if (this.skinLineView[0]?.width > imgCenter.offsetWidth) {
      let size = this.skinLineView[0]?.width / imgCenter.offsetWidth;
      this.imgHeight = this.skinLineView[0]?.height / size + "px";
    } else {
      let size = imgCenter.offsetWidth / this.skinLineView[0]?.width;
      this.imgHeight = this.skinLineView[0]?.height * size + "px";
    }
  }

  public get skinLineViewOut() {
    return (readGetSkinLineView(store) as any).image_nums?.out_game;
  }
  public get imgTable() {
    return [
      { name: "画质", prop: "name" },
      { name: "标记为异常", prop: "mark" },
      { name: "局内异常", prop: "inMark" },
      { name: "局外异常", prop: "outMark" },
    ];
  }
  public get_data: any = {
    image_nums: {
      out_game: {},
      in_game: {},
    },
    bad_nums: 0,
    in_bad_nums: 0,
    in_mark_nums: 0,
    mark_nums: 0,
    mark_quality_nums: 0,
    out_bad_nums: 0,
    out_mark_nums: 0,
    skin_line_id: 0,
    manual_mark_nums: 0,
  };
  public get skinLineViewData() {
    this.get_data = readGetSkinLineView(store);
    return this.get_data;
  }
  public get skinLineViewIn() {
    return (readGetSkinLineView(store) as any).image_nums?.in_game;
  }
  public form = {
    date_version: "",
    scene: "",
    draw: "",
    pkg: "",
    screen: "",
  };
  public defaultData() {
    this.form.date_version = readGetSkinDate(store)[0].date;
    this.form.scene = this.sceneList[0].value;
    this.form.pkg = readGetSkinPkg(store)[0].pkg;
  }
  public get dateList() {
    return readGetSkinDate(store);
  }
  public get pkgList() {
    return readGetSkinPkg(store);
  }
  public get sceneList() {
    return [
      { label: "局外", value: "1" },
      { label: "局内", value: "0" },
    ];
  }
  public get drawList() {
    return ["High", "HD", "Low", "Medium"];
  }
  // public  get skinLineView(){
  //    return   readGetSkinLineView(store)
  // }
  public typeName(type) {
    if (type === "") {
      return "正常";
    }
    if (type === "white_result") {
      return "白模";
    }
    if (type === "stuck") {
      return "画面卡住";
    }
    if (type === "light") {
      return "光照异常";
    }
    if (type === "black_result") {
      return "黑模";
    }
    if (type === "purple_result") {
      return "紫模";
    }
    if (type === "rect_result") {
      return "方块异常";
    }
    if (type === "compare_result") {
      return "对比异常";
    }
  }
  public num = 0;
  public imgStatus = 0;
  public total = 0;
  public numIndex = 0;

  public file_path = "";
  public num1 = 0;
  public rightBtn() {
    let imgData = document.getElementById("imgBox");
    let imgCenter = document.getElementById("center");
    //  if(this.$route.query.imgIndex){
    //    let imgRuIndex=Number(this.$route.query.imgIndex)

    //    this.num=-(this.imgWidth*imgRuIndex)
    //     console.log(this.num)
    //  }

    let imgIndex = (this.num -= imgCenter.offsetWidth);

    let lBtn = document.getElementById("leftBtn");
    let rBtn = document.getElementById("rightBtn");
    if (this.num != this.skinLineView.length * -imgCenter.offsetWidth) {
      this.numIndex++;
      this.$router.push({
        query: {
          ...this.$route.query,
          pkg: this.form.pkg,
          date: this.form.date_version,
          type: this.form.scene,
          quality: this.form.draw,
          imgIndex: this.numIndex - 1,
        },
      });
      imgData.style.left = this.num + "px";
      let imgI = -imgIndex / imgCenter.offsetWidth;
      lBtn.style.backgroundColor = "#E5EFFF";

      this.imgStatus = this.skinLineView[imgI].status;
      if (this.skinLineView[imgI].width > imgCenter.offsetWidth) {
        let size = this.skinLineView[imgI].width / imgCenter.offsetWidth;
        this.imgHeight = this.skinLineView[imgI].height / size + "px";
      } else {
        let size = imgCenter.offsetWidth / this.skinLineView[imgI].width;
        this.imgHeight = this.skinLineView[imgI].height * size + "px";
      }
      // this.imgHeight=this.skinLineView[imgI].height+'px'
      // console.log(this.skinLineView[imgI].abnormal_type)
      this.abnormal_type =
        this.skinLineView[imgI].abnormal_type === undefined
          ? ""
          : this.skinLineView[imgI].abnormal_type;
      this.auto_abnormal_type =
        this.skinLineView[imgI].auto_abnormal_type === undefined
          ? ""
          : this.skinLineView[imgI].auto_abnormal_type;
      this.file_path = this.skinLineView[imgI].file_path;
    } else if (this.num == this.skinLineView.length * -imgCenter.offsetWidth) {
      this.num = 0;

      this.numIndex = 1;
      this.$router.push({
        query: {
          ...this.$route.query,
          pkg: this.form.pkg,
          date: this.form.date_version,
          type: this.form.scene,
          quality: this.form.draw,
          imgIndex: this.numIndex - 1,
        },
      });
      imgData.style.left = 0 + "px";
      lBtn.style.backgroundColor = "#c9caca";

      this.imgStatus = this.skinLineView[0].status;
      if (this.skinLineView[0].width > imgCenter.offsetWidth) {
        let size = this.skinLineView[0].width / imgCenter.offsetWidth;
        this.imgHeight = this.skinLineView[0].height / size + "px";
      } else {
        let size = imgCenter.offsetWidth / this.skinLineView[0].width;
        this.imgHeight = this.skinLineView[0].height * size + "px";
      }
      // this.imgHeight=this.skinLineView[0].height+'px'
      this.abnormal_type = this.skinLineView[0].abnormal_type;
      this.auto_abnormal_type = this.skinLineView[0].auto_abnormal_type;
      this.file_path = this.skinLineView[0].file_path;
    }
  }
  public leftBtn() {
    let lBtn = document.getElementById("leftBtn");
    let rBtn = document.getElementById("rightBtn");
    let imgData = document.getElementById("imgBox");
    let imgCenter = document.getElementById("center");

    if (this.num != 0) {
      lBtn.style.backgroundColor = "#E5EFFF";
      this.numIndex--;
      this.$router.push({
        query: {
          ...this.$route.query,
          pkg: this.form.pkg,
          date: this.form.date_version,
          type: this.form.scene,
          quality: this.form.draw,
          imgIndex: this.numIndex - 1,
        },
      });
      let imgIndex = (this.num += imgCenter.offsetWidth);
      imgData.style.left = this.num + "px";
      let imgI = -imgIndex / imgCenter.offsetWidth;
      if (this.skinLineView[imgI].width > imgCenter.offsetWidth) {
        let size = this.skinLineView[imgI].width / imgCenter.offsetWidth;
        this.imgHeight = this.skinLineView[imgI].height / size + "px";
      } else {
        let size = imgCenter.offsetWidth / this.skinLineView[imgI].width;
        this.imgHeight = this.skinLineView[imgI].height * size + "px";
      }
      //  this.imgHeight=this.skinLineView[imgI].height+'px'
      this.imgStatus = this.skinLineView[imgI].status;

      this.abnormal_type = this.skinLineView[imgI].abnormal_type;
      this.auto_abnormal_type = this.skinLineView[imgI].auto_abnormal_type;
      this.file_path = this.skinLineView[imgI].file_path;
    } else {
      this.numIndex = 1;
      lBtn.style.backgroundColor = "#c9caca";
    }
  }
  public checkType(type) {
    if (type == "Medium") {
      return "mark_medium_nums";
    }
    if (type == "Low") {
      return "mark_low_nums";
    }
    if (type == "High") {
      return "mark_high_nums";
    }
    if (type == "HD") {
      return "mark_hd_nums";
    }
    if (type == "No_Lag") {
      return "mark_no_lag_nums";
    }
    if (type == "Power_Saving") {
      return "mark_power_saving_nums";
    }
    if (type == "Standard") {
      return "mark_standard_nums";
    }
  }
  public imgTableData(item, type) {
    let list = [];
    if (type == "") {
      if (item === "1") {
        for (let i in (readGetSkinLineView(store) as any).image_nums
          ?.out_game) {
          list.push({
            name: i,
            mark: (readGetSkinLineView(store) as any).mark_quality_nums,
            inMark: 0,
            outMark: (readGetSkinLineView(store) as any).image_nums?.out_game[
              i
            ],
          });
        }
      } else {
        if (item == "0") {
          for (let i in (readGetSkinLineView(store) as any).image_nums
            ?.in_game) {
            list.push({
              name: i,
              mark: (readGetSkinLineView(store) as any).mark_quality_nums,
              inMark: (readGetSkinLineView(store) as any).image_nums?.in_game[
                i
              ],
              outMark: 0,
            });
          }
        }
      }
    } else {
      if (item == "1") {
        list.push({
          name: type,
          mark: (readGetSkinLineView(store) as any).mark_quality_nums,
          inMark:
            (readGetSkinLineView(store) as any).image_nums?.in_game[type] ===
            undefined
              ? 0
              : (readGetSkinLineView(store) as any).image_nums?.in_game[type],
          outMark:
            (readGetSkinLineView(store) as any).image_nums?.out_game[type] ===
            undefined
              ? 0
              : (readGetSkinLineView(store) as any).image_nums?.out_game[type],
        });
      } else {
        list.push({
          name: type,
          mark: (readGetSkinLineView(store) as any).mark_quality_nums,
          inMark:
            (readGetSkinLineView(store) as any).image_nums?.in_game[type] ===
            undefined
              ? 0
              : (readGetSkinLineView(store) as any).image_nums?.in_game[type],
          outMark:
            (readGetSkinLineView(store) as any).image_nums?.out_game[type] ===
            undefined
              ? 0
              : (readGetSkinLineView(store) as any).image_nums?.out_game[type],
        });
      }
    }
    return list;
  }

  public async detail(type, typeName) {
    //   dispatchUpdateSkinLineView(store,{
    //     id:2,
    //  project: this.localProject,
    //   status:0,

    // });
    let imgData2 = document.getElementById("imgBox");
    let imgCenter = document.getElementById("center");
    if (type === "success") {
      let imgIndex = Math.abs(this.num) / imgCenter.offsetWidth;
      await dispatchUpdateSkinLineView(store, {
        id: this.skinLineView[imgIndex].id,
        project: this.localProject,
        status: 0,
        abnormal_type: "",
      });
      this.skinLineView[imgIndex].status = 0;
      this.skinLineView[imgIndex].abnormal_type = "";
      if (this.imgStatus != 0) {
        if (this.form.scene == "1") {
          this.get_data.out_mark_nums -= 1;
        } else {
          this.get_data.in_mark_nums -= 1;
        }

        (readGetSkinLineView(store) as any).mark_quality_nums -= 1;
        this.imgTableData(this.form.scene, this.form.draw);
        this.get_data.mark_nums -= 1;
        this.get_data.manual_mark_nums -= 1;
      }
      this.imgStatus = 0;
      this.abnormal_type = "";
      let imgData = document.getElementById("imgBox");
      let imgIndex1 = (this.num -= imgCenter.offsetWidth);
      let lBtn = document.getElementById("leftBtn");
      let rBtn = document.getElementById("rightBtn");
      if (this.num != this.skinLineView.length * -imgCenter.offsetWidth) {
        lBtn.style.backgroundColor = "#E5EFFF";
        this.numIndex++;
        this.$router.push({
          query: {
            ...this.$route.query,
            pkg: this.form.pkg,
            date: this.form.date_version,
            type: this.form.scene,
            quality: this.form.draw,
            imgIndex: this.numIndex - 1,
          },
        });
        imgData.style.left = this.num + "px";
        let imgI = -imgIndex1 / imgCenter.offsetWidth;
        // this.imgHeight=this.skinLineView[imgI].height+'px'
        if (this.skinLineView[imgI].width > imgCenter.offsetWidth) {
          let size = this.skinLineView[imgI].width / imgCenter.offsetWidth;
          this.imgHeight = this.skinLineView[imgI].height / size + "px";
        } else {
          let size = imgCenter.offsetWidth / this.skinLineView[imgI].width;
          this.imgHeight = this.skinLineView[imgI].height * size + "px";
        }
        this.imgStatus = this.skinLineView[imgI].status;

        this.abnormal_type =
          this.skinLineView[imgI].abnormal_type === undefined
            ? ""
            : this.skinLineView[imgI].abnormal_type;
        this.auto_abnormal_type =
          this.skinLineView[imgI].auto_abnormal_type === undefined
            ? ""
            : this.skinLineView[imgI].auto_abnormal_type;
        this.file_path = this.skinLineView[imgI].file_path;
      } else if (
        this.num ==
        this.skinLineView.length * -imgCenter.offsetWidth
      ) {
        this.num = 0;

        this.numIndex = 1;
        this.$router.push({
          query: {
            ...this.$route.query,
            pkg: this.form.pkg,
            date: this.form.date_version,
            type: this.form.scene,
            quality: this.form.draw,
            imgIndex: 0,
          },
        });
        imgData.style.left = 0 + "px";
        lBtn.style.backgroundColor = "#c9caca";

        // this.imgHeight=this.skinLineView[0].height+'px'
        if (this.skinLineView[0].width > imgCenter.offsetWidth) {
          let size = this.skinLineView[0].width / imgCenter.offsetWidth;
          this.imgHeight = this.skinLineView[0].height / size + "px";
        } else {
          let size = imgCenter.offsetWidth / this.skinLineView[0].width;
          this.imgHeight = this.skinLineView[0].height * size + "px";
        }
        this.imgStatus = this.skinLineView[0].status;
        this.abnormal_type = this.skinLineView[0].abnormal_type;
        this.auto_abnormal_type = this.skinLineView[0].auto_abnormal_type;
        this.file_path = this.skinLineView[0].file_path;
      }
    } else {
      let imgCenter2 = document.getElementById("center");
      let imgIndex = Math.abs(this.num) / imgCenter2.offsetWidth;
      await dispatchUpdateSkinLineView(store, {
        id: this.skinLineView[imgIndex].id,
        project: this.localProject,
        status: 1,
        abnormal_type: typeName,
      });
      this.skinLineView[imgIndex].status = 1;
      this.skinLineView[imgIndex].abnormal_type = typeName;

      if (this.imgStatus != 1) {
        if (this.form.scene == "1") {
          this.get_data.out_mark_nums += 1;
        } else {
          this.get_data.in_mark_nums += 1;
        }
        this.get_data.manual_mark_nums += 1;
        this.get_data.mark_nums += 1;
        (readGetSkinLineView(store) as any).mark_quality_nums += 1;
        this.imgTableData(this.form.scene, this.form.draw);
      }
      this.imgStatus = 1;
      this.abnormal_type = typeName;
      let imgData = document.getElementById("imgBox");
      let lBtn = document.getElementById("leftBtn");
      let rBtn = document.getElementById("rightBtn");
      let imgCenter = document.getElementById("center");
      let imgIndex1 = (this.num -= imgCenter.offsetWidth);

      if (this.num != this.skinLineView.length * -imgCenter.offsetWidth) {
        this.numIndex++;
        this.$router.push({
          query: {
            ...this.$route.query,
            pkg: this.form.pkg,
            date: this.form.date_version,
            type: this.form.scene,
            quality: this.form.draw,
            imgIndex: this.numIndex - 1,
          },
        });
        imgData.style.left = this.num + "px";
        let imgI = -imgIndex1 / imgCenter.offsetWidth;
        lBtn.style.backgroundColor = "#E5EFFF";

        // this.imgHeight=this.skinLineView[imgI].height+'px'
        if (this.skinLineView[0].width > imgCenter.offsetWidth) {
          let size = this.skinLineView[0].width / imgCenter.offsetWidth;
          this.imgHeight = this.skinLineView[0].height / size + "px";
        } else {
          let size = imgCenter.offsetWidth / this.skinLineView[0].width;
          this.imgHeight = this.skinLineView[0].height * size + "px";
        }
        this.imgStatus = this.skinLineView[imgI].status;

        this.abnormal_type =
          this.skinLineView[imgI].abnormal_type === undefined
            ? ""
            : this.skinLineView[imgI].abnormal_type;
        this.auto_abnormal_type =
          this.skinLineView[imgI].auto_abnormal_type === undefined
            ? ""
            : this.skinLineView[imgI].auto_abnormal_type;
        this.file_path = this.skinLineView[imgI].file_path;
      } else if (
        this.num ==
        this.skinLineView.length * -imgCenter.offsetWidth
      ) {
        this.num = 0;

        this.numIndex = 1;
        this.$router.push({
          query: {
            ...this.$route.query,
            pkg: this.form.pkg,
            date: this.form.date_version,
            type: this.form.scene,
            quality: this.form.draw,
            imgIndex: 0,
          },
        });
        imgData.style.left = 0 + "px";
        lBtn.style.backgroundColor = "#c9caca";

        // this.imgHeight=this.skinLineView[0].height+'px'
        if (this.skinLineView[0].width > imgCenter.offsetWidth) {
          let size = this.skinLineView[0].width / imgCenter.offsetWidth;
          this.imgHeight = this.skinLineView[0].height / size + "px";
        } else {
          let size = imgCenter.offsetWidth / this.skinLineView[0].width;
          this.imgHeight = this.skinLineView[0].height * size + "px";
        }
        this.imgStatus = this.skinLineView[0].status;
        this.abnormal_type = this.skinLineView[0].abnormal_type;
        this.auto_abnormal_type = this.skinLineView[0].auto_abnormal_type;
        this.file_path = this.skinLineView[0].file_path;
      }
    }

    // await dispatchGetSkinLineView(store,{
    //   project:this.localProject,
    //   pkg:this.form.pkg,
    //   quality:this.form.draw,
    //   type:Number(this.form.scene),
    //   date:this.form.date_version,
    // })
    // let imgData=document.getElementById('imgBox')
    //  imgData.style.left=this.num+'px';
  }
}
